import type { ListStateEvent, Timeout } from '../../types'
import { workerResetLists } from '../actions/workerActions'
import { ListAction, ListType } from '../constants/enums'
import { LinkedList } from '../utilities/linkedlist'
import { pubSubList } from './pubSub'

export type List = LinkedList<ListType>
export type Lists = Partial<Record<ListType, List>>

// root list store
export const activeLists: Lists = {}

if (typeof window !== 'undefined') {
    window.__MFC_APP_LISTS__ = activeLists
}

const listChanges = {
    interval: null as Timeout,
}

export const initListChanges = () => {
    clearInterval(listChanges.interval)
    listChanges.interval = setInterval(broadcastListChanges, 15000)
    return listChanges.interval
}

function forceListChanges() {
    clearInterval(listChanges.interval)
    broadcastListChanges()
    initListChanges()
}

function broadcastListChanges() {
    const updated = {}
    Object.entries(activeLists).forEach(([key, list]) => {
        if (list.changed) {
            pubSubList.emit(key, list)
            updated[key] = list
        }
        list.changed = false
    })

    pubSubList.emit('UPDATE_COMPLETE', updated)
}

export function deleteLists(data: ListStateEvent['data']) {
    const { lists } = data
    lists.forEach((list) => {
        const { key } = list
        if (!key) return
        delete activeLists[key]
    })
}

export function resetLists(data: ListStateEvent['data']) {
    const { lists } = data

    lists.forEach((list) => {
        const { values, key } = list
        activeLists[key] = new LinkedList(values, key, workerResetLists)
        pubSubList.emit(key, activeLists[key])
    })
}

export function modifyLists(data: ListStateEvent['data']) {
    const { lists, forceUIUpdate } = data
    lists.forEach((data) => {
        const { action, item, list, reference } = data

        switch (action) {
            case ListAction.INSERT:
                // console.log(`About to insert ${item} after ${reference} in ${list}.`)
                activeLists[list].insertBefore(item, reference)
                break
            case ListAction.REMOVE:
                // console.log(`About to remove ${item} from ${list}.`)
                activeLists[list].remove(item)
                break
        }
    })
    if (forceUIUpdate) {
        forceListChanges()
    }
}
